import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { listYourNotifications } from '../../services/NotificationService';
import { settingsPaginationNotification } from '../../common/lang';

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async ({ userId, page }, thunkAPI) => {
    if (!userId) return thunkAPI.rejectWithValue('No user');
    try {
      const response = await listYourNotifications(
        userId,
        Math.max(0, (page || 1) - 1),
        settingsPaginationNotification.size,
        settingsPaginationNotification.sort
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error fetching notifications');
    }
  }
);

const initialState = {
  items: [],
  totalPages: 1,
  loading: false,
  error: null,
  currentPage: 1,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    resetNotifications() {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.items = Array.isArray(action.payload?.content) ? action.payload.content : [];
        state.totalPages = Math.max(1, action.payload?.totalPages || 1);
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setCurrentPage, resetNotifications } = notificationsSlice.actions;

export default notificationsSlice.reducer;
